module.exports = __webpack_public_path__ + "img/01_noff_open_L2.68129785.svg";